// actions.js

export const setPaymentMethodRe = (paymentMethod) => {
    return {
      type: 'SET_PAYMENT_METHOD',
      payload: paymentMethod
    };
  };
  